import { BreakpointScale } from './types';

export const breakpoints: BreakpointScale = {
  sm: 545,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1650,
};
